import React from 'react';
import CrashedComponentV2 from './CrashedComponentV2';

const CrashedComponent = ({
    onReload,
    canReload,
}: {
    onReload: () => void;
    canReload: boolean;
}) => {
    return <CrashedComponentV2 onReload={onReload} canReload={canReload} />;
};
export default CrashedComponent;
